module.exports = __webpack_public_path__ + "static/media/broken.37c472bb.svg";